import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import type { Role } from '@/types/api';

interface RoleGateProps {
  roles: Role | Role[];
  fallback?: ReactNode;
  children: ReactNode;
}

export function RoleGate({ roles, fallback = null, children }: RoleGateProps) {
  const { hasRole } = useAuth();
  if (!hasRole(roles)) return <>{fallback}</>;
  return <>{children}</>;
}
